/**
 * 邀请码 / 兑换码的字母表与格式。
 *
 * 这些码要靠人念出来、抄下来、在手机上敲进去，所以：
 *   · 去掉 0/O/1/I/L —— 手写和屏幕上都分不清，是错码的头号来源
 *   · 只用大写，输入时统一转换，用户不必关心大小写
 *   · 显示时按 4 位分组，敲起来不容易串行；比对前一律先归一化
 */

/** 32 个字符。256 % 32 === 0，所以下面取随机数不会有模偏差。 */
export const CODE_ALPHABET = '23456789ABCDEFGHJKLMNPQRSTUVWXYZ'

/** 邀请码长度（32^8 ≈ 1.1e12，配合服务端限速足够抗猜） */
export const INVITE_CODE_LENGTH = 8

/** 兑换码长度。这个直接对应钱，给足熵。 */
export const REDEEM_CODE_LENGTH = 12

/**
 * 用户输进来的东西一律先过这里：去掉分隔符和空格、转大写。
 * 「abcd-efgh」「ABCD EFGH」「abcdefgh」归一化后是同一个码。
 */
export function normalizeCode(raw: string): string {
  return raw.toUpperCase().replace(/[^0-9A-Z]/g, '')
}

/** 归一化之后是不是一个长度正确、字符合法的码 */
export function isValidCode(raw: string, length: number): boolean {
  const c = normalizeCode(raw)
  if (c.length !== length) return false
  for (const ch of c) if (!CODE_ALPHABET.includes(ch)) return false
  return true
}

/** 展示用：每 4 位插一个连字符 */
export function formatCode(code: string, group = 4): string {
  return (normalizeCode(code).match(new RegExp(`.{1,${group}}`, 'g')) ?? []).join('-')
}

/** 生成随机码。Worker 和 Node 都有全局 crypto，两边算法一致。 */
export function randomCode(length: number): string {
  const bytes = crypto.getRandomValues(new Uint8Array(length))
  let out = ''
  for (const b of bytes) out += CODE_ALPHABET[b % CODE_ALPHABET.length]
  return out
}
